import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { Relationship } from './useCampaignAccessQuery';
import { CampaignDTO } from './useCampaignsQuery';
import { queryKeys } from './queryKeys';

interface UpsertCampaignParams {
  campaign: CampaignDTO;
  sharedAccess?: Relationship[];
}

export const UPSERT_CAMPAIGN_MK = 'upsertCampaignMK';

const upsertCampaign = ({ campaign, sharedAccess }: UpsertCampaignParams) => {
  return campaign.id
    ? authFetch(`/Adviser/Campaigns/Update/${campaign.id}`, {
        method: 'PUT',
        ...httpBodyOptions({ ...campaign, sharedAccess }, true),
      })
    : authFetch('/Adviser/Campaigns', {
        method: 'POST',
        ...httpBodyOptions({ ...campaign, sharedAccess }, true),
      });
};

export const useUpsertCampaignMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(upsertCampaign, {
    mutationKey: UPSERT_CAMPAIGN_MK,

    onSuccess: async () => {
      queryClient.invalidateQueries(queryKeys.campaigns());
    },
  });
};
